/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Client_Claude_HelpInputs */

const en_directory_mcp_client_claude_help = /** @type {(inputs: Directory_Mcp_Client_Claude_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One command registers the server for this project:`)
};

const zh_directory_mcp_client_claude_help = /** @type {(inputs: Directory_Mcp_Client_Claude_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一条命令即可为该项目注册服务器：`)
};

/**
* | output |
* | --- |
* | "One command registers the server for this project:" |
*
* @param {Directory_Mcp_Client_Claude_HelpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_client_claude_help = /** @type {((inputs?: Directory_Mcp_Client_Claude_HelpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Client_Claude_HelpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_client_claude_help(inputs)
	return zh_directory_mcp_client_claude_help(inputs)
});
export { directory_mcp_client_claude_help as "directory.mcp.client_claude_help" }